import { render, staticRenderFns } from "./NuevoConsultorio.vue?vue&type=template&id=0883e53c"
import script from "./NuevoConsultorio.vue?vue&type=script&lang=js"
export * from "./NuevoConsultorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports